<template>
  <div
    class="grow-0 transition-[height] duration-500"
    :class="
      openMenu && menuDirection === 'vertical' ? 'h-0 overflow-y-hidden' : 'h-'
    "
  >
    <div
      class="bg-white flex flex-col pt-[15px] w-full max-md:max-w-full panel-main-header"
    >
      <div
        class="flex items-stretch justify-between gap-5 mx-4 md:mx-9 max-md:max-w-full max-md:flex-wrap mr-4 max-md:mr-2.5"
      >
        <div
          class="flex h-[42px] items-center justify-between gap-5 w-full md:w-fit"
        >
          <button
            @click="toggleSidebar()"
            class="cursor-pointer menu-container"
          >
            <!-- <img src="@/assets/icons/svg/menu.svg" /> -->
            <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 46 46" fill="none">
              <rect x="0.5" y="0.5" width="45" height="45" rx="22.5" stroke="#E5E5E5"/>
              <path d="M32 18.75H14C13.59 18.75 13.25 18.41 13.25 18C13.25 17.59 13.59 17.25 14 17.25H32C32.41 17.25 32.75 17.59 32.75 18C32.75 18.41 32.41 18.75 32 18.75Z" fill="black"/>
              <path d="M32 23.75H14C13.59 23.75 13.25 23.41 13.25 23C13.25 22.59 13.59 22.25 14 22.25H32C32.41 22.25 32.75 22.59 32.75 23C32.75 23.41 32.41 23.75 32 23.75Z" fill="black"/>
              <path d="M32 28.75H14C13.59 28.75 13.25 28.41 13.25 28C13.25 27.59 13.59 27.25 14 27.25H32C32.41 27.25 32.75 27.59 32.75 28C32.75 28.41 32.41 28.75 32 28.75Z" fill="black"/>
              </svg>
          </button>
          <a href="/" class="flex items-center">
            <img
              src="@/assets/images/header/logo-horizontal.svg"
              loading="lazy"
              class="aspect-[2.13] object-contain max-h-[42px] object-center w-[102px] overflow-hidden self-center shrink-0 max-w-full my-auto"
            />
          </a>
        </div>
        <div
          class="hidden h-[42px] md:flex items-center justify-between gap-3 max-md:max-w-full max-md:flex-wrap"
        >
          <qooBtn
            type="secondary"
            icon="star2.svg"
            text="Favourites"
            classList="h-[42px]"
            paddingStyle="px-[25.25px] py-[10.37px]"
            width="w-5"
            @clickBtn="favouritesPage"
          ></qooBtn>
          <VDropdown :triggers="['click']" placement="bottom" :distance="16">
            <qooBtn
              v-if="+showWorksheetRoute"
              icon="worksheet.svg"
              classList="h-[42px]"
              paddingStyle="px-[25.25px] py-[10.37px]"
              text="Submit Worksheet"
              :hasCounter="true"
              :counterNumber="store.worksheetId?.length"
            ></qooBtn>
            <!-- @clickBtn="worksheet" -->
            <template #popper="{ hide }">
              <div class="dropdown-container p-4">
                <div
                  class="dropdown bg-white rounded-lg p-6 w-[426px] min-h-[200px]"
                >
                  <popupWorksheet
                    :models="data"
                    :hide="hide"
                    :counterNumber="store.worksheetId"
                    @submitWorksheet="worksheet(hide)"
                  >
                  </popupWorksheet>
                </div>
              </div>
            </template>
          </VDropdown>
        </div>
      </div>
      <div
        class="qoo-line min-h-[1px] w-full mt-[14px] max-md:max-w-full"
        :class="openMenu ? '' : 'bg-menu-color'"
      ></div>
    </div>
    <MainMenuHorizontal
      v-if="menuDirection === 'horizontal'"
      class="transition-transform duration-500"
      :class="openMenu ? 'translate-y-0' : '-translate-y-[140vh]'"
      @closeSidebar="closeSidebar"
    />
    <MainMenuVertical
      v-else-if="menuDirection === 'vertical'"
      :openMenu="openMenu"
      @closeSidebar="closeSidebar"
    />
  </div>
</template>

<script setup>
import { ref, watchEffect, onMounted, watch } from "vue";
import MainMenuHorizontal from "./MainMenuHorizontal.vue";
import MainMenuVertical from "./MainMenuVertical.vue";
import qooBtn from "./common/qooBtn.vue";
import { useRouter } from "vue-router";
import { useWorksheets } from "@/store/worksheet.js";
import { useVerticalMenu } from "@/store/verticalMenu";
import popupWorksheet from "./PopupWorksheet.vue";
import { useQuery } from "@tanstack/vue-query";
import { modelsSaleFish } from "@/services/axios/saleFish/model.service.js";
import { floorsQuery } from "@/services/axios/floors.service.js";

const menuDirection = process.env.VUE_APP_MENU_DIRECTION;
const showWorksheetRoute = process.env.VUE_APP_SHOW_WORKSHEET;

const router = useRouter();
const openMenu = ref(false);
const store = ref({});
store.value = useWorksheets();
const orders = ref([]);
let apiFrameEl = null;
const data = ref([]);

const toggleSidebar = () => {
  openMenu.value = !openMenu.value;

  // if (openMenu.value) {
  //   document.getElementsByTagName("html")[0].style.overflow = "hidden";
  // } else {
  //   document.getElementsByTagName("html")[0].style.overflow = "auto";
  // }
};

const { data: modelsQuerySaleFish, isLoading: getModelsLoadingSaleFish } = useQuery({
  queryKey: ["modelsSaleFish"],
  queryFn: modelsSaleFish,
  select: (data) => data,
  enabled: true,
});

watchEffect(() => {
  if (modelsQuerySaleFish.value) {
    setTimeout(async () => {
      let res;
      data.value = [];
      res = modelsQuerySaleFish.value.data;
      const compare = (a, b) => {
        return a.modelSize - b.modelSize;
      };
      res.sort(compare);
      data.value = res
      if(store.value) {
        store.value.cleanInvalidWorksheets(data.value);
      }
    }, 200);
  }
});

const closeSidebar = () => {
  openMenu.value = false;
};

const favouritesPage = () => {
  if (openMenu.value) {
    toggleSidebar();
  }
  router.push({ name: "favouritesPage" });
};

const worksheet = (hide) => {
  hide()
  if (openMenu.value) {
    toggleSidebar();
  }
  router.push({ name: "worksheet" });
};

onMounted(() => {
  apiFrameEl = document.getElementById("api-frame");
  store.value = useWorksheets();
  if(data.value.length) {
    store.value.cleanInvalidWorksheets(data.value);
  }
});

const verticalMenuStore = useVerticalMenu();

watch(
  () => openMenu.value,
  () => {
    if (menuDirection === "vertical") {
      verticalMenuStore.setIsOpen(openMenu.value);
    }
    if(apiFrameEl &&
      apiFrameEl.style) {
      if (
        menuDirection === "vertical" &&
        openMenu.value
      ) {
        apiFrameEl.style.height = "calc(100vh - 0rem)";
      } else {
        apiFrameEl.style.height = "calc(100vh - 72px)";
      }
    }
  },
);
</script>

<style lang="scss">
@import "MainHeader.scss";

.qoo-line {
  transition: 1.2s ease all;
}

$menu-width: 24px;
$menu-height: 24px;

.menu-container {
  border-radius: 30px;
  // border: 1px solid #000;
  background: rgba(217, 217, 217, 0);
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;

  & .menu {
    width: $menu-width;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;

    & .menu-item {
      transition: 0.5s ease all;
      display: block;
      width: $menu-width;
      height: 2.5px;
      box-sizing: border-box;
      border-radius: 5px;
      background: #000000;
    }

    &.open {
      .menu-item {
        // background: #000000;
        width: 26px;

        &:first-child {
          transform: rotate(45deg);
          transform-origin: 6px 5px;
        }

        &:nth-child(2) {
          opacity: 0;
        }

        &:nth-child(3) {
          transform: rotate(-45deg);
          transform-origin: 5px -2px;
        }
      }
    }
  }
}

.bg-menu-color {
  background-color: #b3b3b3;
  opacity: 1;
}
</style>
<style lang="scss" scoped>
.dropdown {
  box-shadow: 0px 2px 4px 0px #0000001a;
}
</style>
